import {
  Component, Input,
  OnInit
} from '@angular/core';
import {AvailableTrafficPack} from '../../interfaces/available-traffic-pack';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app-state';
import {map, mergeMap, take} from 'rxjs/operators';
import {of} from 'rxjs';
import {AppActions} from '../../../store/app-actions';
import {PersistanceService} from '../../../services/persistance.service';
import {ContractData} from '../../interfaces/contract-data';

@Component({
  selector: 'app-available-traffic-packs',
  templateUrl: './available-traffic-packs.component.html',
  styleUrls: ['./available-traffic-packs.component.less']
})
export class AvailableTrafficPacksComponent implements OnInit {

  @Input() trafficPacks: AvailableTrafficPack[] = [];
  @Input() pnoId: number;
  @Input() disabled = false;

  protected visible = false;
  protected currentTrafficPack?: AvailableTrafficPack;
  responsiveOptions = [
    {
      breakpoint: '1200px',
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: '992px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '576px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  constructor(private store: Store<{ app: AppState }>,
              private persistanceService: PersistanceService) {
  }

  ngOnInit(): void {
   this.addEventListenerForClickAndBlockCloseButtonWhileFormPending();
  }

  buyTrafficPack(trafficPack: AvailableTrafficPack): void {
    if (this.disabled) return;

    // Return if already loading
    if (this.trafficPacks.find(x => !!x.loading) !== undefined) {
      return;
    }

    // Getting contract data from store or web server
    this.store.select('app', 'contractData')
      .pipe(
        take(1),
        mergeMap(stored => {

            if (!stored) {
              trafficPack.loading = true;
            }

            return stored
              ? of(stored)
              : this.persistanceService.getContractDataFromLocalstorage()
                .pipe(
                  map((response: ContractData | null) => {
                    if (response) {
                      this.store.dispatch(AppActions.setContractData({contractData: response}));
                    }
                    trafficPack.loading = false;

                    return response;
                  }),
                );
          }),
      )
      .subscribe(() => {});

    this.currentTrafficPack = trafficPack;
    if (this.currentTrafficPack){
      this.visible = true;
    }
  }

  addEventListenerForClickAndBlockCloseButtonWhileFormPending(): void {
    try {
      window.addEventListener('click', (event: MouseEvent) => {
        if (!!this.currentTrafficPack?.loading) {
          event.stopPropagation();
          event.preventDefault();
        }
      }, true);
    } catch (e) {
      console.error(e);
    }
  }
}
